import gsap from 'gsap';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from '../';
const Wrapper = styled.div `
  svg {
    --icon-color: ${({ theme }) => theme.secondary.blendToBackground(800)};
  }
`;
export const IconSearch = (props) => {
    const wrapperRef = createRef();
    useEffect(() => {
        if (!wrapperRef.current) {
            return;
        }
        const circle = wrapperRef.current.querySelector('svg:first-child');
        const line = wrapperRef.current.querySelector('svg:last-child');
        if (!circle || !line) {
            return;
        }
        if (props.running) {
            gsap.to(circle, {
                x: '1px',
                y: '1px',
                duration: 0.15,
            });
            wrapperRef.current.tween = gsap.to(line, {
                keyframes: [
                    {
                        '--offset': '12px',
                        duration: 0.15,
                    },
                    {
                        repeat: -1,
                        duration: 0.7,
                        rotate: '+=360deg',
                    },
                ],
            });
            return;
        }
        if (wrapperRef.current.tween) {
            const tween = wrapperRef.current.tween;
            setTimeout(() => {
                tween.pause();
                gsap.to(line, {
                    keyframes: [
                        {
                            rotate: '0deg',
                            duration: 0.15,
                        },
                        {
                            '--offset': '23px',
                            duration: 0.15,
                            clearProps: true,
                            onStart: () => {
                                gsap.to(circle, {
                                    x: '0px',
                                    y: '0px',
                                    duration: 0.15,
                                    clearProps: true,
                                });
                            },
                        },
                    ],
                });
            }, 500);
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Icon.Search, null)));
};
//# sourceMappingURL=Search.js.map